import { PageDetectionUtil } from '~shared/utils/page-detection.util';
export type SkipLinksType = { id: string; label: string };
export type SkipToMenuMappersProp = { links: SkipLinksType[]; getPage: (s: string) => boolean }[];
const defaultMainContent = 'main-page-content';

export const skipToMenuMappers: SkipToMenuMappersProp = [
  {
    links: [
      {
        id: 'payment-method-container',
        label: 'GLOBAL.A11Y.SKIP_TO_MAIN_CONTENT',
      },
    ],
    getPage: PageDetectionUtil.isPaymentPage,
  },
  {
    links: [
      {
        id: defaultMainContent,
        label: 'GLOBAL.A11Y.SKIP_TO_MAIN_CONTENT',
      },
    ],
    getPage: PageDetectionUtil.isReviewPage,
  },
];
